import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { formatDate } from '@domain-group/javascript-utils'

import type { CustomDeadlineModel } from '@models/types'

import useCustomDeadline from '@hooks/useCustomDeadline'

import { getDeadlineTypeDescription } from '@functions/customDeadline'
import { formatEntityCount } from '@functions/entity'

interface CustomDeadlineListItemProps {
  customDeadline: CustomDeadlineModel,
  isClickable?: boolean,
}

const CustomDeadline = (props: CustomDeadlineListItemProps) => {
  const {
    customDeadline,
    customDeadline: {
      alert_emails = [], deadline_time, description, title,
    },
    isClickable,
  } = props

  const { callbacks: { createOrEditCustomDeadline } } = useCustomDeadline(customDeadline)

  const formattedDeadlineTime = formatDate(deadline_time, 'ISO8601', 'h:mm a')

  const emailsLength = alert_emails?.length
  const alertUsers = emailsLength ? `(${formatEntityCount({ entityCount: emailsLength, entityString: 'User' })})` : ''

  const deadlineTypeDescription = getDeadlineTypeDescription(customDeadline)

  return (
    <DashboardModuleListItem
      onClick={isClickable ? () => createOrEditCustomDeadline() : undefined}
      secondaryText={description}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        <Box flexDirection="column" textAlign="right" fontSize="xsmall">
          <Text marginBottom="xsmall">{formattedDeadlineTime} {alertUsers}</Text>

          <Text color="bodyFontLightColor">{deadlineTypeDescription}</Text>
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default CustomDeadline
